// extracted by mini-css-extract-plugin
export var form = "style-module--form--2mMSd";
export var form_input = "style-module--form_input--2yWJk";
export var form_accept = "style-module--form_accept--QGp96";
export var form_btn = "style-module--form_btn--2dMxA";